import { z } from 'zod';
import { mongoObjectIdString } from './object-id-helpers.js';

export const ObjectiveSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    objectiveName: z.string().min(1, 'form.validation.objectiveNameRequired'),
    description: z.string().optional(),
    unitId: mongoObjectIdString.optional(),
    startDate: z.string().or(z.date()).optional(),
    endDate: z.string().or(z.date()).optional(),
    status: z.string().default('Not Started'),
    relatedKpis: z.array(z.string()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});
export const CreateObjectiveSchema = ObjectiveSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateObjectiveSchema = ObjectiveSchema.partial();
export const ObjectiveFormSchema = ObjectiveSchema;
